import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {

    getAlGroupsForDropdown,
    getEstatesByGroupID,
    getDivisionByEstateID,
    getDailyTaskDetailReportData,
    GetAllOperationEntityByGroupID,
    GetFieldsByCollectionPointID
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function GetAllOperationEntityByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;
}


async function getDivisionByEstateID(divisionID) {
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true && item[1]["operationEntityID"] == divisionID) {
            array[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return array;
}


async function GetFieldsByCollectionPointID(divisionID) {
    var divisionArray = [];
    const response = await CommonGet('/api/Field/GetFieldsByCollectionPointID', 'id=' + divisionID);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            divisionArray[item[1]["fieldID"]] = item[1]["fieldName"]
        }
    }
    return divisionArray;
}

async function getDailyTaskDetailReportData(data) {

    var model = {
        EstateID: parseInt(data.estateID),
        DivisionID: parseInt(data.divisionID),
        FieldID: parseInt(data.fieldID),
        SearchDate: data.searchDate
    };
    const response = await CommonPost('/api/SundryLabourCheckListReport/GetSundryLabourCheckListReportData', null, model);
    return response.data;
}
